module.exports = __webpack_public_path__ + "static/media/builder_users.d1bd7a65.png";